import {
	TRIGGER_VALIDATE_VPA_API_CALL_SUCCESS,
	TRIGGER_NON_BP_MERCHANT_INFO_API_SUCCESS,
	TRIGGER_VALIDATE_MOBILE_API_CALL_SUCCESS,
	TRIGGER_CLEAR_MERCHANT_INFO_DETAILS,
} from 'redux/actionTypes';

const initialState = {};

// export const locale[];

const MerchantAccountDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case TRIGGER_VALIDATE_VPA_API_CALL_SUCCESS:
		case TRIGGER_NON_BP_MERCHANT_INFO_API_SUCCESS:
		case TRIGGER_VALIDATE_MOBILE_API_CALL_SUCCESS:
			return {
				...state,
				...action.data,
			};
		case TRIGGER_CLEAR_MERCHANT_INFO_DETAILS:
			return {};
		default:
			return state;
	}
};

export default MerchantAccountDetailsReducer;
